import CompanionBillingView from "@components/companion-v2/CompanionBillingView";
import { DSCardWrapper } from "@components/design-system/molecules";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AvailableSettingsSections,
  useCompanion,
} from "@hooks/use-companion";

import CompanionPermissions from "./settings/CompanionPermissions";

const SettingsAccordionItem = ({
  value,
  title,
  description,
  isOpen,
  onToggle,
  children,
}) => (
  <div className="flex flex-col gap-sm">
    <DSCardWrapper
      interactive
      variant="ghost"
      onClick={onToggle}
      aria-label={`${isOpen ? "Collapse" : "Expand"} ${title}`}
      dataTestId={`companion-settings-${value}-header`}
    >
      <div className="flex flex-row items-center justify-between gap-md">
        <div className="flex flex-col">
          <h4 className="text-primary">{title}</h4>
          <p className="text-sm text-secondary">{description}</p>
        </div>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`text-secondary transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </div>
    </DSCardWrapper>
    {isOpen && (
      <div
        className="bg-primary rounded-large p-md"
        data-testid={`companion-settings-${value}-panel`}
      >
        {children}
      </div>
    )}
  </div>
);

const CompanionSettings = () => {
  const { settingsSection, setSettingsSection } = useCompanion();

  const toggle = (section) => {
    setSettingsSection(settingsSection === section ? null : section);
  };

  return (
    <div
      className="flex flex-col gap-md"
      data-testid="companion-settings-accordion"
    >
      <SettingsAccordionItem
        value={AvailableSettingsSections.billing}
        title="Billing"
        description="View your treat balance, recent activity, and buy more treats."
        isOpen={settingsSection === AvailableSettingsSections.billing}
        onToggle={() => toggle(AvailableSettingsSections.billing)}
      >
        <CompanionBillingView />
      </SettingsAccordionItem>
      <SettingsAccordionItem
        value={AvailableSettingsSections.permissions}
        title="Permissions"
        description="Actions Companion can run without asking again."
        isOpen={
          settingsSection === AvailableSettingsSections.permissions
        }
        onToggle={() => toggle(AvailableSettingsSections.permissions)}
      >
        <CompanionPermissions />
      </SettingsAccordionItem>
    </div>
  );
};

export default CompanionSettings;
